<div class="row account p-2 m-2">
    <form [formGroup]="editInvoiceForm">
        <div class="row account">
            <div class="col-md-12 border-bottom pb-3 border-gray mb-3">
                <div class="d-flex align-items-center justify-content-between">
                    <h4 class="text-dark fw-bold mb-0">Update Invoice Details</h4>
                    <button class="btn shadow-none" mat-dialog-close>
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- Invoice No -->
            <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                <div class="form-group accountsinp mb-3">
                    <label for="">Invoice No<sup class="text-danger">*</sup></label>
                    <div class="d-flex align-items-center">
                        <input *ngIf="isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Invoice No" id="InvoiceNoctrl" formControlName="InvoiceNo" />
                        <input disabled *ngIf="!isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Invoice No" id="InvoiceNoctrl" formControlName="InvoiceNo" />
                    </div>
                    <small class="text-danger" *ngIf="ff.InvoiceNo.touched && ff.InvoiceNo.errors?.['required']">
                        Invoice Number is required
                    </small>
                    <small class="text-danger" *ngIf="ff.InvoiceNo.touched && ff.InvoiceNo.errors?.['pattern']">
                        Only numbers are allowed
                    </small>
                </div>
            </div>

            <!-- Invoice Value -->
            <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                <div class="form-group accountsinp mb-3">
                    <label for="">Invoice Value<sup class="text-danger">*</sup></label>
                    <div class="d-flex align-items-center">
                        <input *ngIf="isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Invoice Value" id="InvoiceValuectrl" formControlName="InvoiceValue" />
                        <input disabled *ngIf="!isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Invoice Value" id="InvoiceValuectrl" formControlName="InvoiceValue" />
                    </div>
                    <small class="text-danger" *ngIf="ff.InvoiceValue.touched && ff.InvoiceValue.errors?.['required']">
                        Invoice Value is required
                    </small>
                </div>
            </div>

            <!-- Number of Articles -->
            <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                <div class="form-group accountsinp mb-3">
                    <label for="">Number of Articles<sup class="text-danger">*</sup></label>
                    <div class="d-flex align-items-center">
                        <input *ngIf="isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter No. of Article" id="NoofArticlectrl" formControlName="NoofArticle" />
                        <input disabled *ngIf="!isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter No. of Article" id="NoofArticlectrl" formControlName="NoofArticle" />
                    </div>
                    <small class="text-danger" *ngIf="ff.NoofArticle.touched && ff.NoofArticle.errors?.['required']">
                        Number of Articles is required
                    </small>
                </div>
            </div>

            <!-- Weight -->
            <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                <div class="form-group accountsinp mb-3">
                    <label for="">Weight<sup class="text-danger">*</sup></label>
                    <div class="d-flex align-items-center">
                        <input *ngIf="isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Weight Value" id="Weightctrl" formControlName="Weight" />
                        <input disabled *ngIf="!isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Weight Value" id="Weightctrl" formControlName="Weight" />
                    </div>
                    <small class="text-danger" *ngIf="ff.Weight.touched && ff.Weight.errors?.['required']">
                        Weight is required
                    </small>
                    <small class="text-danger" *ngIf="ff.Weight.touched && ff.Weight.errors?.['pattern']">
                        Enter a valid weight (e.g. 10 or 10.5)
                    </small>
                </div>
            </div>

            <!-- Customer Name -->
            <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                <div class="form-group accountsinp mb-3">
                    <label for="">Customer Name<sup class="text-danger">*</sup></label>
                    <div class="d-flex align-items-center">
                        <input *ngIf="isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Customer Name" id="customerNamectrl" formControlName="customerName" />
                        <input disabled *ngIf="!isRoleSuperVisor" type="text" class="form-control me-1 shadow-none"
                            placeholder="Enter Customer Name" id="customerNamectrl" formControlName="customerName" />
                    </div>
                    <small class="text-danger" *ngIf="ff.customerName.touched && ff.customerName.errors?.['required']">
                        Customer Name is required
                    </small>
                </div>
            </div>

            <!-- Invoice Attachment -->
            <div class="col-xl-6 col-md-6 col-12 col-sm-6">
                <div class="form-group accountsinp mb-3">
                    <label for="">Invoice Attachment</label>

                    <!-- No file yet -->
                    <div class="d-flex align-items-center justify-content-center" *ngIf="!acc?.path">
                        <input type="file" accept="image/*,.pdf" (change)="fileChangeEventAttachment($event)"
                            class="form-control me-1 shadow-none" id="PODctrl" formControlName="POD" />
                        <button class="btn btn-dark btn-sm px-4 ms-3" type="button" (click)="preview()"
                            mat-raised-button>
                            Preview
                        </button>
                    </div>

                    <!-- File exists -->
                    <div *ngIf="acc?.path" class="viewFile mt-2 text-center">
                        <!-- Image -->
                        <div class="viewImage" *ngIf="!isPdf(acc?.path)">
                            <img [src]="acc?.path.includes('http') ? acc?.path : apiUrl + '/' + acc?.path"
                                alt="Invoice Attachment" width="100" height="100" class="rounded shadow-sm"
                                (click)="viewImages(acc?.path, 'Attachment')" />
                            <div class="d-flex justify-content-center mt-2">
                                <button class="btn btn-outline-dark btn-sm me-2" type="button" (click)="editFile()"
                                    title="Replace File">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button class="btn btn-outline-danger btn-sm" type="button" (click)="deleteFile()"
                                    title="Delete File">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </div>
                        </div>

                        <!-- PDF -->
                        <div *ngIf="isPdf(acc?.path)" class="pdf-preview mt-2 flex">
                            <a [href]="acc?.path.includes('http') ? acc?.path : apiUrl + '/' + acc?.path"
                                target="_blank" class="d-flex align-items-center justify-content-center">
                                <i class="fa-regular fa-file-pdf text-danger me-2 fs-4"></i>
                                View Attached PDF
                            </a>
                            <div class="d-flex justify-content-center mt-2">
                                <button class="btn btn-outline-dark btn-sm me-2 editbtn" type="button" (click)="editFile()"
                                    title="Replace File">
                                    <i class="fa-solid fa-pen"></i>
                                </button>
                                <button class="btn btn-outline-danger btn-sm editbtn" type="button" (click)="deleteFile()"
                                    title="Delete File">
                                    <i class="fa-solid fa-trash"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Action buttons -->
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="col-xl-12 col-md-12 col-12 col-sm-12 text-center">
                <button mat-raised-button [mat-dialog-close]="true" class="btn btn-dark me-1">
                    Cancel
                </button>
                <button mat-raised-button (click)="updateInvoice()" class="btn btn-dark ms-1" type="button">
                    Update
                </button>
            </div>
        </div>
    </form>
</div>